import { render, staticRenderFns } from "./fhRecord.vue?vue&type=template&id=50fe520a"
import script from "./fhRecord.vue?vue&type=script&lang=js"
export * from "./fhRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports